import React from 'react';

import { TimesLightIcon } from '../../../../shared/icons/icons';
import Typography from '../../../typography/typography';
import { FilterChipValue } from '../../filter-chips';

import './filter-chip.scss';

interface FilterChipProps extends FilterChipValue {
  onClick: ({ categoryCode, valueCode }) => void;
}

function FilterChip(props: FilterChipProps) {
  const { categoryName, categoryCode, valueName, onClick, valueCode } = props;

  return (
    <Typography
      aria-label={`remove ${valueName}`}
      className="filter-chip"
      onClick={() => onClick({ categoryCode, valueCode })}
      size="small"
      styleName="container"
      tag="button"
      weight="heavy"
    >
      {categoryName}: <strong>{valueName}</strong>
      <TimesLightIcon styleName="close-icon" />
    </Typography>
  );
}

export default React.memo(FilterChip);
